import { ready } from '../utils/ready'
import flyoutMenu from './flyout-menu'

const pvFlyoutBreakpoint = 960
const hasChildrenSelector = '.pvMainMenu__item--hasChildren'
const submenuHasChildrenSelector = '.pvMainMenu__submenu__item--hasChildren'
let submenusInit = false
let scrollTopBeforeOpen

const toggleSubmenu = (submenu) => {
    submenu.classList.toggle('pvMainMenu__submenu--open')
}

const handleBackTrigger = (t) => t.addEventListener('click', (e) => {
    const submenu = t.closest('.pvMainMenu__submenu')
    toggleSubmenu(submenu)
})

const createItemAndInsert = (a, submenu) => {
    const item = document.createElement('div')
    item.classList.add(...['pvMainMenu__submenu__item', 'js_cloned'])
    item.appendChild(a)
    submenu.prepend(item)
}

const onTriggerClick = (e) => {
    e.preventDefault()
    const parent = e.target.closest('.pvMainMenu__item, .pvMainMenu__submenu__item')
    const submenu = parent.querySelector('.pvMainMenu__submenu')
    toggleSubmenu(submenu)
}

const initClickableSubmenus = (items) => {
    items.forEach((item) => {
        const button = item.querySelector(':scope > button') // button is used for links without a URL
        const anchor = item.querySelector(':scope > a') // a is used for links with a URL
        const submenu = item.querySelector('.pvMainMenu__submenu')

        if (!anchor && !button) {
            return
        }

        if (!submenu) {
            return
        }

        const clickEl = button ? button : anchor

        clickEl.addEventListener('click', onTriggerClick)

        if (anchor) {
            const clonedAnchor = anchor.cloneNode(true)
            const submenuInner = submenu.querySelector('.pvMainMenu__submenu__list')
            createItemAndInsert(clonedAnchor, submenuInner)
        }
    })

    submenusInit = true
}

const destroyClickableSubmenus = (items) => {
    items.forEach((item) => {
        const submenu = item.querySelector('.pvMainMenu__submenu--open')

        if (submenu) {
            item.classList.remove('pvMainMenu__submenu--open')
        }

        item.querySelector('a').removeEventListener(
            'click',
            onTriggerClick
        )

        const cloned = item.querySelector('.js_cloned')

        if (cloned) {
            item.querySelector('.js_cloned').remove()
        }
    })

    submenusInit = false
}

const initFlyoutClass = () => !document.body.classList.contains('pvFlyoutInit') && document.body.classList.add('pvFlyoutInit')

const toggleFlyout = (mql) => {
    if (mql.matches) {
        initFlyoutClass()

        if (!submenusInit) {
            initClickableSubmenus(document.querySelectorAll(hasChildrenSelector))
            initClickableSubmenus(document.querySelectorAll(submenuHasChildrenSelector))
        }
    } else {
        document.documentElement.classList.contains('noScroll') &&
        document.documentElement.classList.remove('noScroll')

        document.body.classList.contains('pvFlyoutOpen') &&
        document.body.classList.remove('pvFlyoutOpen')

        document.body.classList.contains('pvFlyoutInit') &&
        document.body.classList.remove('pvFlyoutInit')

        if (submenusInit) {
            destroyClickableSubmenus(
                document.querySelectorAll(hasChildrenSelector)
            )

            destroyClickableSubmenus(
                document.querySelectorAll(submenuHasChildrenSelector)
            )
        }
    }
}

ready(() => {
    const flyoutButtonTriggers = document.querySelectorAll('.js_pvFlyout__button')

    flyoutButtonTriggers.forEach((b) => {
        b.addEventListener('click', () => {
            const siteOuterWrapper = document.querySelector('.siteOuterWrapper')

            if (!siteOuterWrapper) {
                return
            }

            if (document.body.classList.contains('pvFlyoutOpen')) {
                document.documentElement.scrollTop = scrollTopBeforeOpen
                document.body.scrollTop = scrollTopBeforeOpen
                siteOuterWrapper.style.position = null
                siteOuterWrapper.style.top = null
                document.documentElement.style.scrollBehavior = null
            } else {
                scrollTopBeforeOpen = document.body.scrollTop || document.documentElement.scrollTop
                document.documentElement.style.scrollBehavior = 'unset'
                document.documentElement.scrollTop = 0
                document.body.scrollTop = 0
                siteOuterWrapper.style.top = -scrollTopBeforeOpen + 'px'
            }
        })
    })

    flyoutMenu(pvFlyoutBreakpoint, 'js_pvFlyout__button', ['pvFlyoutOpen'], ['pvFlyoutInit'])

    const backTriggers = document.querySelectorAll('.pvMainMenu__submenu__back')
    backTriggers.forEach((t) => handleBackTrigger(t))

    const resize = window.matchMedia(`(max-width:${pvFlyoutBreakpoint}px)`)
    resize.addEventListener('change', toggleFlyout)
    toggleFlyout(resize)
})
